export default "__VITE_ASSET__C1mZeu1N__"